module.exports = __webpack_public_path__ + "static/media/DWCaslon-Italic.ec8fa27a.woff";